module.exports = __webpack_public_path__ + "img/formules.e28449ed.png";